// extracted by mini-css-extract-plugin
module.exports = {"lgLightbox":"lightbox_lgLightbox__UtNaA"};